import { Chip } from '@acsbe/ui';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { BillingMethod } from '../../../context/BillingContext';
import { getPaymentMethodState } from './common';

type ChipByStateProps = {
  card: BillingMethod;
};

export const ChipByState: FunctionComponent<ChipByStateProps> = ({ card }) => {
  const {
    isDeclinedCard,
    isInvalidCard,
    isExpiredCard,
    expiresSoon,
    isZipInvalid,
  } = getPaymentMethodState(card);
  const { t } = useTranslation();

  if (isDeclinedCard || isInvalidCard) {
    return <Chip scale="danger">{t('DECLINED_CARD')}</Chip>;
  }

  if (isExpiredCard) {
    return <Chip scale="danger">{t('EXPIRED_CARD')}</Chip>;
  }

  if (isZipInvalid) {
    return <Chip scale="danger">{t('BILLING_PAGE.INVALID_ZIP')}</Chip>;
  }

  if (expiresSoon) {
    return (
      <Chip scale="warning">
        {t('BILLING_PAGE.EXPIRED_IN_DAYS', { prompt: card.daysToExpire })}
      </Chip>
    );
  }

  return null;
};
